import { render, staticRenderFns } from "./NotificationUpdate.vue?vue&type=template&id=5a9156f5&"
import script from "./NotificationUpdate.vue?vue&type=script&lang=js&"
export * from "./NotificationUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports